import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import { roleUrl } from '@/constants/urls';
import {
  columnTools,
  columnUsers,
  columnPermissions,
  columnCategory,
  hasColumn,
} from '@/constants/fields';
import MessageCell from '@/components/table/MessageCell';
import SystemFlag from '@/components/SystemFlag';
import NameDescriptionRow from '@/components/table/NameDescriptionRow';
import { roleGroupings } from '../constants';
import RoleToolsMenu from '../containers/RoleToolsMenu';
import { adminPermissionsCount } from '../helper';

const RoleRow = ({
  category,
  className,
  columns,
  defaultRole,
  onCheckBoxClick,
  role,
  upward,
  selectable,
}) => (
  <NameDescriptionRow
    className={clsx('aridhia-role-row', className, defaultRole && 'aridhia-active-row')}
    code={role.code}
    columns={columns}
    description={role.description}
    entity="role"
    highlight={defaultRole}
    href={roleUrl(role)}
    message="configurations.default.role.hover"
    name={role.name}
    onSelect={() => onCheckBoxClick(role.code, category)}
    selectable={selectable}
    selected={role.selected}
    system={role.system}
    warning={defaultRole}
  >
    {hasColumn(columns, columnCategory) && (
      <Table.Cell>
        <SystemFlag
          messageId={`roles.grouping.${role.grouping}`}
          solid={role.grouping === roleGroupings.TOKENS}
        />
      </Table.Cell>
    )}
    {hasColumn(columns, columnPermissions) && (
      <MessageCell
        messageId="permissions.count"
        messageArgs={{ total: role.metrics.all_permissions, admin: adminPermissionsCount(role) }}
      />
    )}
    {hasColumn(columns, columnUsers) && (
      <MessageCell
        messageId="users.count"
        messageArgs={{ total: role.metrics.all_users, approved: role.metrics.approved_users }}
      />
    )}
    {hasColumn(columns, columnTools) && (
      <Table.Cell collapsing>
        <RoleToolsMenu
          category={category}
          role={role}
          upward={upward}
          url={roleUrl(role, '#')}
        />
      </Table.Cell>
    )}
  </NameDescriptionRow>
);

export default RoleRow;
